import { api } from "../../lib";
import { TaskSummary } from "./roleTasks.service";

export interface GroupTasksResponse {
  groupId: string;
  groupName: string;
  tasks: TaskSummary[];
}

export interface GroupTaskEntry {
  id: string;
  groupId: string;
  groupName: string;
  taskId: string;
  taskName: string;
  taskSlug: string;
}

export interface AllGroupTasksResponse {
  groupTasks: GroupTaskEntry[];
}

export const groupTasksService = {
  getAll: async (): Promise<AllGroupTasksResponse> => {
    return api.get<AllGroupTasksResponse>("/admin/group-tasks");
  },

  getByGroup: async (groupId: string): Promise<GroupTasksResponse> => {
    return api.get<GroupTasksResponse>(`/admin/groups/${groupId}/tasks`);
  },

  setForGroup: async (
    groupId: string,
    taskIds: string[]
  ): Promise<GroupTasksResponse> => {
    return api.put<GroupTasksResponse>(`/admin/groups/${groupId}/tasks`, {
      taskIds,
    });
  },
};
